import React, { useEffect } from "react";
import theme from "theme";

const LoadingWidgetDots = (props) => {
  useEffect(() => {
    const customBounceKeyframes = `
      @keyframes custom-bounce {
        0%, 100% {
          transform: translateY(0);
        }
        50% {
          transform: translateY(-6px); /* Ajusta este valor para mayor desplazamiento */
        }
      }
    `;

    const styleSheet = document.styleSheets[0];
    styleSheet.insertRule(customBounceKeyframes, styleSheet.cssRules.length);
  }, []);

  return (
    <div className="flex justify-start items-center mt-2 ml-2">
      <div className="flex justify-center items-center">
        <div className="flex space-x-1">
          <div
            className="rounded-full"
            style={{
              width: props.size,
              height: props.size,
              backgroundColor: theme.palette.grey[300],
              animation: "custom-bounce 800ms infinite ease-in-out",
              animationDelay: "-0.36s",
            }}
          ></div>
          <div
            className="rounded-full"
            style={{
              width: props.size,
              height: props.size,
              backgroundColor: theme.palette.grey[300],
              animation: "custom-bounce 800ms infinite ease-in-out",
              animationDelay: "-0.16s",
            }}
          ></div>
          <div
            className="rounded-full"
            style={{
              width: props.size,
              height: props.size,
              backgroundColor: theme.palette.grey[300],
              animation: "custom-bounce 800ms infinite ease-in-out",
            }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default LoadingWidgetDots;
